module.exports = __webpack_public_path__ + "f87d741328bd3845f01d69c5cebf94ba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-19.png
// module id = 2129
// module chunks = 0